import { Page } from '@/components/page.tsx';

import { buildFeatureUnavailableBody, buildFeatureUnavailableHeadline } from '@/utils/feature-availability-utils.ts';

interface Props {
    featureName: string;
}

export const FeatureUnavailablePage = ({ featureName }: Props) => {
    return (
        <Page className="flex flex-col items-center justify-center gap-4 p-6 text-center">
            <h1 className="text-2xl font-bold">{buildFeatureUnavailableHeadline(featureName)}</h1>
            <p className="max-w-prose text-base">{buildFeatureUnavailableBody(featureName)}</p>
        </Page>
    );
};
